/* eslint-disable */

import * as clientService from "./httpsClient";

export const login = async (body) => {
  try {
    return await clientService.postAuthApi(`auth/login`, body);
  } catch (error) {
    throw error;
  }
};
